import { useEffect } from "react";
import { toast } from "sonner";
import { useI18n } from "../lib/i18n";

/** Fills the cart from a stored previous order, keeping only products still on sale. */
export const useReorder = (channel, products, setItems) => {
  const { t } = useI18n();

  useEffect(() => {
    if (products.length === 0) return;
    const raw = localStorage.getItem("khf_reorder");
    if (!raw) return;
    localStorage.removeItem("khf_reorder");
    let payload;
    try {
      payload = JSON.parse(raw);
    } catch {
      return;
    }
    if (payload?.channel !== channel || !Array.isArray(payload.items)) return;
    const available = payload.items
      .map((it) => products.find((p) => p.id === it.product_id))
      .map((p, i) => (p ? { ...payload.items[i], price: p.price, name: p.name, unit: p.unit } : null))
      .filter(Boolean);
    if (available.length === 0) {
      toast.error(t("reorder_none"));
      return;
    }
    setItems(available);
    toast.success(
      available.length === payload.items.length ? t("reorder_ok") : t("reorder_partial")
    );
  }, [products, channel, setItems, t]);
};
